import { Component, inject, OnInit } from '@angular/core';

import { Router, RouterModule, RoutesRecognized } from '@angular/router';

// NgBootstrap - Fontawesome
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { faFile, faRightFromBracket, faArrowRightFromBracket, faStickyNote, faFileContract, faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// Services
import { AuthService } from '../../../auth/services/auth.service';


// Third Party
import { NgxPermissionsModule } from 'ngx-permissions';

// Environments
import { environment } from '../../../../environments/environment';


@Component({
    selector: 'app-header',
    imports: [RouterModule, NgbDropdownModule, FontAwesomeModule, NgxPermissionsModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  demoMode = environment.demoMode;

  authSrv = inject(AuthService);

  routeData: any;

  faRightFromBracket = faRightFromBracket;
  faFile = faFile;
  faStickyNote=faStickyNote;
  faArrowRightFromBracket=faArrowRightFromBracket;
  faFileContract = faFileContract;
  faKey = faKey;

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        this.routeData = data.state.root.firstChild?.routeConfig;
      }
    });
  }
}
